import React from "react";

import styles from "./FormTreeView.module.css";

import TreeView, { INode, INodeRendererProps } from "react-accessible-treeview";

import IFormTreeViewProps from "./dto/IFormTreeViewProps";
import FormTreeViewState from "./dto/FormTreeViewState";
import { Checkbox, ColorClassNames, FontClassNames, Icon, Label } from "@fluentui/react";
import { IFlatMetadata } from "react-accessible-treeview/dist/TreeView/utils";
import TreeviewConfig from "../../../../dto/Form/TreeviewConfig";
import TreeviewItem from "../../../../dto/Form/TreeviewItem";

export default class FormTreeView extends React.Component<IFormTreeViewProps, FormTreeViewState> {

    constructor(props: IFormTreeViewProps) {
        super(props);
        this.state = new FormTreeViewState();
    }

    public render() {
        let config = this.props.field.config as TreeviewConfig;

        let selectedOptions = this.getParsedSelectedValues();

        let rootNode: INode = {
            id: "root",
            name: "root",
            parent: null,
            children: []
        };
        let treeLookup: { [key: string]: INode } = {};
        for(let curItem of config.items) {
            let node: INode = {
                id: curItem.id,
                name: curItem.name,
                parent: curItem.parentId ? curItem.parentId : "root",
                children: []
            };
            treeLookup[curItem.id] = node;
        }

        let treeNodes: INode[] = [ rootNode ];
        for(let curItem of config.items) {
            let curNode = treeLookup[curItem.id];
            if(curItem.parentId) {
                let parentNode = treeLookup[curItem.parentId];
                parentNode.children.push(curNode.id);
            } else {
                rootNode.children.push(curNode.id);
            }

            treeNodes.push(curNode);
        }

        return (
            <div>
                {this.props.field.title && <Label required={this.props.field.required}>{this.props.field.title}</Label>}
                <TreeView data={treeNodes} nodeRenderer={(node) => this.renderNode(node, selectedOptions)} className={styles.treeView} multiSelect={true} selectedIds={selectedOptions}></TreeView>
                {this.props.errorMessage && <div className={`${ColorClassNames.red} ${FontClassNames.small} ${styles.errorMessage}`}>{this.props.errorMessage}</div>}
            </div>
        );
    }

    private renderNode = (props: INodeRendererProps<IFlatMetadata>, selectedOptions: string[]): JSX.Element => {
        return (
            <div key={props.element.id} style={{ paddingLeft: 20 * (props.level - 1) }} onClick={props.handleExpand} className={styles.treeViewItem}>
                {props.element.children.length > 0 && <Icon iconName={props.isExpanded ? "ChevronDown" : "ChevronRight"} className={styles.treeViewExpandedState}></Icon>}
                <Checkbox checked={props.isSelected} onChange={(_ev, selected) => this.onNodeSelected(selectedOptions, props.element, selected)} className={styles.treeViewCheckbox}></Checkbox>
                {props.element.name}
            </div>
        )
    }

    private getParsedSelectedValues = (): string[] => {
        if(!this.props.selectedValues) {
            return [];
        }

        try {
            return JSON.parse(this.props.selectedValues);
        } catch(e) {
            console.error(e);
            return [];
        }
    }

    private onNodeSelected = (selectedOptions: string[], node: INode, selected?: boolean): void => {
        let config = this.props.field.config as TreeviewConfig;
        if(!config.singleSelect) {
            selectedOptions = selectedOptions || [];
            if(selected) {
                selectedOptions.push(node.id.toString());
            } else {
                selectedOptions = selectedOptions.filter(s => s !== node.id);
            }

            selectedOptions = this.checkParentSelection(selectedOptions, node);
            selectedOptions = this.toggleChildSelection(selectedOptions, node, selected);
        } else {
            selectedOptions = [];
            if(selected) {
                selectedOptions.push(node.id.toString());
            }
        }
        
        this.props.onChange(JSON.stringify(selectedOptions));
    }

    private checkParentSelection = (selectedOptions: string[], node: INode): string[] => {
        if(!node.parent) {
            return selectedOptions;
        }

        let config = this.props.field.config as TreeviewConfig;
        let parentNode = config.items.find(i => i.id === node.parent);
        if(!parentNode) {
            return selectedOptions;
        }

        let parentToCheck = parentNode;

        let allChildrenSelected = true;
        for(let curItem of config.items) {
            if(curItem.parentId === parentToCheck.id && !selectedOptions.some(s => s === curItem.id)) {
                allChildrenSelected = false;
                break;
            }
        }

        if(allChildrenSelected) {
            if(!selectedOptions.some(s => s === parentToCheck.id)) {
                selectedOptions.push(parentToCheck.id);
            }
        } else {
            selectedOptions = selectedOptions.filter(s => s !== parentToCheck.id);
        }

        selectedOptions = this.checkParentSelection(selectedOptions, {
            id: parentToCheck.id,
            name: parentToCheck.name,
            parent: parentToCheck.parentId,
            children: []
        });

        return selectedOptions;
    }

    private toggleChildSelection = (selectedOptions: string[], node: INode | TreeviewItem, selected?: boolean): string[] => {
        let config = this.props.field.config as TreeviewConfig;
        for(let curItem of config.items) {
            if(curItem.parentId === node.id) {
                if(selected) {
                    if(!selectedOptions.some(s => s === curItem.id)) {
                        selectedOptions.push(curItem.id);
                    }
                } else {
                    selectedOptions = selectedOptions.filter(s => s !== curItem.id);
                }
                selectedOptions = this.toggleChildSelection(selectedOptions, curItem, selected);
            }
        }
        return selectedOptions;
    }
}